var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"schema":_vm.schema,"state":_vm.state,"row-class-name":_vm.computeRowClassName,"display-errors":""}})}
var staticRenderFns = []

export { render, staticRenderFns }